import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OperadorasService {

  constructor(private readonly http: HttpClient) { }

  getCamposOperadoras(body: any) {
    return this.http.post(`/apiconnect/orders/order/operators-fields`,body);
  }

  getListaOperadoras(url , body: any) {
    return this.http.post(`/apiconnect/importation/order/operators${url}`,body);
  }

  getDetalheBeneficio(idProduto: any) {
    return this.http.get(`/apiconnect/importation/benefit/benefit-informations/${idProduto}/products`);
  }

  getManualOperadora(idEmpresaOperadora: any) {
    return this.http.get(`/apiconnect/importation/report/operator-manual/${idEmpresaOperadora}/suppliers`, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
